var map = {
	"./ad.svg": 55735,
	"./ae.svg": 27606,
	"./af.svg": 82242,
	"./ag.svg": 38924,
	"./ai.svg": 27088,
	"./al.svg": 856,
	"./am.svg": 12013,
	"./ao.svg": 85842,
	"./ar.svg": 80605,
	"./as.svg": 308,
	"./at.svg": 76475,
	"./au.svg": 4572,
	"./aw.svg": 47626,
	"./az.svg": 1138,
	"./ba.svg": 22922,
	"./bb.svg": 83326,
	"./bd.svg": 48430,
	"./be.svg": 27637,
	"./bf.svg": 86555,
	"./bg.svg": 29936,
	"./bh.svg": 2960,
	"./bi.svg": 45521,
	"./bj.svg": 39730,
	"./bm.svg": 84839,
	"./bo.svg": 42226,
	"./br.svg": 23484,
	"./bs.svg": 39162,
	"./bt.svg": 17585,
	"./bw.svg": 46400,
	"./by.svg": 2903,
	"./bz.svg": 28785,
	"./ca.svg": 9456,
	"./cd.svg": 76524,
	"./cf.svg": 68088,
	"./cg.svg": 56053,
	"./ch.svg": 56036,
	"./ci.svg": 16170,
	"./ck.svg": 89362,
	"./cl.svg": 82526,
	"./cm.svg": 67205,
	"./cn.svg": 47069,
	"./co.svg": 97912,
	"./cr.svg": 84219,
	"./cu.svg": 28397,
	"./cv.svg": 95174,
	"./cw.svg": 68862,
	"./cy.svg": 72434,
	"./cz.svg": 56940,
	"./de.svg": 1606,
	"./dj.svg": 55086,
	"./dk.svg": 8283,
	"./dm.svg": 39039,
	"./do.svg": 39381,
	"./dz.svg": 47944,
	"./ec.svg": 49806,
	"./ee.svg": 44425,
	"./eg.svg": 76196,
	"./er.svg": 76189,
	"./es.svg": 41104,
	"./et.svg": 54810,
	"./fi.svg": 14053,
	"./fj.svg": 24663,
	"./fk.svg": 45939,
	"./fm.svg": 17955,
	"./fo.svg": 93303,
	"./fr.svg": 59567,
	"./ga.svg": 98631,
	"./gb.svg": 75282,
	"./gd.svg": 19287,
	"./ge.svg": 35299,
	"./gg.svg": 5201,
	"./gh.svg": 67088,
	"./gi.svg": 11195,
	"./gl.svg": 91900,
	"./gm.svg": 157,
	"./gn.svg": 24777,
	"./gq.svg": 60840,
	"./gr.svg": 57721,
	"./gt.svg": 1358,
	"./gu.svg": 70779,
	"./gw.svg": 46536,
	"./hk.svg": 46369,
	"./hn.svg": 91334,
	"./hr.svg": 1107,
	"./ht.svg": 13986,
	"./hu.svg": 65589,
	"./id.svg": 79427,
	"./ie.svg": 51228,
	"./il.svg": 14683,
	"./im.svg": 43849,
	"./in.svg": 17002,
	"./io.svg": 65977,
	"./iq.svg": 31598,
	"./ir.svg": 64591,
	"./is.svg": 11502,
	"./it.svg": 10860,
	"./je.svg": 93574,
	"./jm.svg": 68067,
	"./jo.svg": 18791,
	"./jp.svg": 20240,
	"./ke.svg": 6120,
	"./kg.svg": 46769,
	"./kh.svg": 41018,
	"./ki.svg": 50419,
	"./km.svg": 42883,
	"./kn.svg": 62640,
	"./kp.svg": 82463,
	"./kr.svg": 15976,
	"./kw.svg": 31111,
	"./ky.svg": 9609,
	"./kz.svg": 85801,
	"./la.svg": 42360,
	"./lb.svg": 45499,
	"./li.svg": 96080,
	"./lk.svg": 13763,
	"./lr.svg": 14502,
	"./ls.svg": 94511,
	"./lt.svg": 94455,
	"./lu.svg": 48685,
	"./lv.svg": 75171,
	"./ly.svg": 22549,
	"./ma.svg": 55033,
	"./mc.svg": 4849,
	"./md.svg": 73499,
	"./me.svg": 84590,
	"./mg.svg": 79498,
	"./mh.svg": 54195,
	"./mk.svg": 3555,
	"./ml.svg": 29785,
	"./mm.svg": 54598,
	"./mn.svg": 64986,
	"./mo.svg": 92372,
	"./mp.svg": 88222,
	"./mq.svg": 81527,
	"./mr.svg": 4007,
	"./ms.svg": 82013,
	"./mt.svg": 18272,
	"./mu.svg": 13194,
	"./mv.svg": 74689,
	"./mw.svg": 57802,
	"./mx.svg": 69076,
	"./my.svg": 89501,
	"./mz.svg": 9598,
	"./na.svg": 12582,
	"./nato.svg": 30101,
	"./ne.svg": 37815,
	"./nf.svg": 2345,
	"./ng.svg": 37630,
	"./ni.svg": 60415,
	"./nl.svg": 85117,
	"./no.svg": 42322,
	"./np.svg": 69690,
	"./nr.svg": 68430,
	"./nu.svg": 49850,
	"./nz.svg": 92815,
	"./om.svg": 83858,
	"./pa.svg": 59572,
	"./pe.svg": 12120,
	"./pf.svg": 31627,
	"./pg.svg": 58225,
	"./ph.svg": 75701,
	"./pk.svg": 44407,
	"./pl.svg": 51262,
	"./pn.svg": 72900,
	"./pr.svg": 94223,
	"./ps.svg": 38593,
	"./pt.svg": 29502,
	"./pw.svg": 51875,
	"./py.svg": 42896,
	"./qa.svg": 24437,
	"./ro.svg": 47670,
	"./rs.svg": 61682,
	"./ru.svg": 34532,
	"./rw.svg": 89058,
	"./sa.svg": 62936,
	"./sb.svg": 707,
	"./sc.svg": 1451,
	"./sd.svg": 18699,
	"./se.svg": 88458,
	"./sg.svg": 21917,
	"./si.svg": 75517,
	"./sk.svg": 12347,
	"./sl.svg": 94250,
	"./sm.svg": 61472,
	"./sn.svg": 21741,
	"./so.svg": 45841,
	"./sr.svg": 22052,
	"./ss.svg": 85674,
	"./st.svg": 97008,
	"./sv.svg": 52489,
	"./sx.svg": 41909,
	"./sy.svg": 46616,
	"./sz.svg": 23440,
	"./tc.svg": 25232,
	"./td.svg": 72705,
	"./tg.svg": 58218,
	"./th.svg": 29369,
	"./tibet.svg": 92034,
	"./tj.svg": 6668,
	"./tk.svg": 41541,
	"./tm.svg": 99341,
	"./tn.svg": 48736,
	"./to.svg": 92443,
	"./tr.svg": 59581,
	"./tt.svg": 43474,
	"./tv.svg": 37085,
	"./tw.svg": 61999,
	"./tz.svg": 20625,
	"./ua.svg": 90722,
	"./ug.svg": 60475,
	"./us.svg": 47887,
	"./uy.svg": 13697,
	"./uz.svg": 62234,
	"./ve.svg": 59164,
	"./vi.svg": 15021,
	"./vn.svg": 12313,
	"./vu.svg": 74873,
	"./ws.svg": 29515,
	"./ye.svg": 82366,
	"./za.svg": 43200,
	"./zm.svg": 14575,
	"./zw.svg": 9567
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44855;